import { initializeApp, FirebaseApp } from 'firebase/app'
import { getAuth, Auth } from 'firebase/auth'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  Firestore,
} from 'firebase/firestore'
import { getFunctions, Functions } from 'firebase/functions'
import { firebaseConfig } from '../config/firebase'

// Firebase instances
let app: FirebaseApp
let auth: Auth
let db: Firestore
let functions: Functions

// Initialize Firebase - Production only (no emulators)
export const initializeFirebase = () => {
  if (!app) {
    app = initializeApp(firebaseConfig)
    auth = getAuth(app)
    db = initializeFirestore(app, {
      localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
      }),
    })
    functions = getFunctions(app, 'europe-west2')

    console.log('🔥 Firebase initialized with offline persistence')
  }

  return { app, auth, db, functions }
}

// Export initialized instances
export const getFirebaseApp = () => {
  if (!app) {
    initializeFirebase()
  }
  return app
}

export const getFirebaseAuth = () => {
  if (!auth) {
    initializeFirebase()
  }
  return auth
}

export const getFirebaseDb = () => {
  if (!db) {
    initializeFirebase()
  }
  return db
}

export const getFirebaseFunctions = () => {
  if (!functions) {
    initializeFirebase()
  }
  return functions
}

// Export getFirestore alias for compatibility
export const getFirestore = getFirebaseDb

// Export getFunctions alias for compatibility
export { getFirebaseFunctions as getFunctions }
